import React from "react";
import { useNavigate } from "react-router-dom";
import emailfail from "../../assets/email-fail.png";
import "./signupverification.css"


const EmailVerificationFail = () => {
  const navigate = useNavigate()
  return (
    <div className="d-flex justify-content-center align-items-center emailFail_main_conatiner fn_Nunito">
      <div className="text-center">
        <img src={emailfail} className="emailFailimage" />
        <div className="mt-5">
          <span className="fw_700 fs_22 fs_sm_18 mt-2 ">
            Sorry, Verification Failed!
          </span>
        </div>

        <div>
          <p className="col-8 col-sm-9 mx-auto color_747f9e fs_14 fs_sm_12">
            Your email verification link is expired, please request a new
            verification link.
          </p>
        </div>
        <button className="emailFail_btn text-white fs_12 px-4 py-2 mt-3" onClick={() => navigate('/login')}>
          Request Verification Link
        </button>
      </div>
    </div>
  );
};

export default EmailVerificationFail;
